import {
  Autocomplete,
  Avatar,
  Chip,
  DialogContent,
  Grid2,
  IconButton,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { Fragment, useState } from "react";
import validator from "validator";
import * as Yup from "yup";
import CopyLinkIco from "../../../../assets/icons/CopyLinkIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import ShareIco from "../../../../assets/icons/ShareIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import DropDownSelect from "../../../../component/Select";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { CommonDialogStyle } from "./StyledComponent";

function ShareQuickMatch({
  shareDialogOpen,
  handleShareDialogClose,
  handleShareInvite,
  isLoading,
  title = "Share Quick Match",
  condition = false,
  statusOptions,
  CustomMenuItem,
  jobData,
}) {
  const [generate, setGenerate] = useState({ copied: false });
  const [inputValue, setInputValue] = useState("");
  const handleShareDelete = (values, setFieldValue, option) => {
    const updatedValue = values.shareData.filter((item, i) => item !== option);
    setFieldValue("shareData", updatedValue);
  };

  const validationSchema = Yup.object({
    shareData: Yup.array()
      .of(
        Yup.object().shape({
          email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        })
      )
      .test(
        "at-least-one-email",
        "At least one email is required",
        (value) => Array.isArray(value) && value.length > 0
      )
      .test(
        "unique-emails",
        "Duplicate emails are not allowed",
        function (value) {
          if (!Array.isArray(value)) return true;

          const emails = value.map((item) => item.email);
          const uniqueEmails = new Set(emails);

          return emails.length === uniqueEmails.size;
        }
      ),
  });

  const handleKeyDown = (e, setFieldValue, values) => {
    const inputValue = e.target.value.trim();

    if ((e.key === "Tab" || e.key === "Enter") && inputValue) {
      e.preventDefault();
      setInputValue("");

      if (validator.isEmail(inputValue)) {
        const newShareData = [
          ...values.shareData,
          {
            email: inputValue,
            type: "",
            ...(condition === true
              ? { send_resume_portal: false, max_resumes: 0 }
              : {}),
          },
        ];
        setFieldValue("shareData", newShareData);
        e.target.value = "";
      }
    } else if (e.key === "Backspace" && e.target.value === "") {
      const updatedShareData = [...values.shareData];
      updatedShareData.pop();
      setFieldValue("shareData", updatedShareData);
    }
  };

  const handleCopyMouseLeave = () => {
    setTimeout(
      () =>
        setGenerate((prev) => ({
          ...prev,
          copied: false,
        })),
      200
    );
  };

  const handleCopyClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setGenerate((prev) => ({
        ...prev,
        copied: true,
      }));
    } catch (error) {}
  };

  return (
    <CommonDialogStyle
      maxWidth={condition ? "700px" : "sm"}
      fullWidth
      open={shareDialogOpen}
      // onClose={handleShareDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Formik
        initialValues={{ shareData: [] }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log(values, "sfjbsjkfbsfgjkkgsjnsgknj");
          handleShareInvite(values.shareData);
        }}
      >
        {({ values, setFieldValue, handleSubmit, errors, touched }) => {
          console.log(values, "sfskfnsklfnsnkjknl");
          return (
            <Form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid2 container spacing={2}>
                  <Grid2 size={12}>
                    <CommonGrid2
                      display={"flex"}
                      justifyContent={"space-between"}
                      flexDirection={"row"}
                      gap={"10px"}
                      alignItems={"center"}
                    >
                      <ShareIco size={"25"} />

                      <IconButton onClick={handleShareDialogClose}>
                        <XCloseIco />
                      </IconButton>
                      {/* <CommonButton
                        onClick={handleShareDialogClose}
                        padding={"10px"}
                        background={"rgba(127, 86, 217, 0.04)"}
                        border="rgba(127, 86, 217, 0.5)"
                        height={"100%"}
                        value={<XCloseIco />}
                        boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
                      /> */}
                    </CommonGrid2>
                  </Grid2>

                  <Grid2 size={12}>
                    <Typography
                      fontSize={"18px"}
                      color={"#101828"}
                      fontWeight={600}
                    >
                      {title}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <StyledFlexRowView alignItems={"flex-start"}>
                      <div style={{ width: "100%" }}>
                        <Autocomplete
                          multiple
                          freeSolo
                          options={[]}
                          limitTags={2}
                          value={values.shareData}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                variant="outlined"
                                label={option.email}
                                {...getTagProps({ index })}
                                onDelete={() => {
                                  handleShareDelete(
                                    values,
                                    setFieldValue,
                                    option
                                  );
                                }}
                              />
                            ))
                          }
                          renderInput={(params) => {
                            return (
                              <TextField
                                {...params}
                                variant="outlined"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: null,
                                  onKeyDown: (e) =>
                                    handleKeyDown(e, setFieldValue, values),
                                }}
                                placeholder="Enter Email id"
                                error={
                                  touched.shareData && Boolean(errors.shareData)
                                }
                                helperText={
                                  touched.shareData && errors.shareData
                                    ? errors.shareData
                                    : ""
                                }
                              />
                            );
                          }}
                        />
                        <span style={{ fontSize: "10px" }}>
                          (Please type the next email ID and press the 'Enter'
                          button)
                        </span>
                      </div>
                    </StyledFlexRowView>
                  </Grid2>

                  {values.shareData.map((user, index) => (
                    <CommonGrid2
                      item
                      display={"flex"}
                      flexDirection={"column"}
                      size={12}
                      gap={"8px"}
                    >
                      <CommonGrid2
                        display={"flex"}
                        justifyContent={"start"}
                        flexDirection={"row"}
                        gap={"10px"}
                        alignItems={"center"}
                        marginTop={"8px"}
                        key={index}
                        size={12}
                        flexWrap={"wrap"}
                      >
                        <CommonGrid2 display={"flex"}>
                          <Chip
                            avatar={
                              <Avatar
                                sx={{
                                  margin: "0px !important",
                                  width: "40px !important",
                                  fontSize: "20px !important",
                                  height: "40px !important",
                                  color: "#fff !important",
                                  textTransform: "capitalize",
                                }}
                              >
                                {user.email.charAt(0)}
                              </Avatar>
                            }
                            label={user.email}
                          />
                        </CommonGrid2>
                        <CommonGrid2
                          item
                          display={"flex"}
                          justifyContent={"end"}
                          alignItems={"center"}
                          gap={"10px"}
                          flexWrap={"wrap"}
                        >
                          {condition === "summary" && (
                            <CommonGrid2
                              display={"flex"}
                              alignItems={"center"}
                              gap={"5px"}
                            >
                              <CommonTextField
                                label="Name"
                                placeholder="Enter Name"
                                variant="outlined"
                                value={user?.name || ""}
                                required={true}
                                labelShrink="7px"
                                width={"150px"}
                                onChange={(e) => {
                                  const updatedShareData = values.shareData.map(
                                    (item, i) => {
                                      if (i === index) {
                                        return {
                                          ...item,
                                          name: e.target.value,
                                        };
                                      }
                                      return item;
                                    }
                                  );
                                  setFieldValue("shareData", updatedShareData);
                                }}
                              />
                            </CommonGrid2>
                          )}
                          {condition === true && (
                            <Fragment>
                              <DropDownSelect
                                marginTop="0px"
                                // removeAnimation={true}
                                data={statusOptions}
                                sizeMedium={"-11px"}
                                title={"Select type"}
                                handleRenderValue={(selected) => selected}
                                valueChange={true}
                                CustomMenuItem={CustomMenuItem}
                                customStyle={{
                                  "& .MuiSelect-select": {
                                    padding: "5px 32px 5px 10px !important",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                  },
                                  "& label": {
                                    fontSize: "13px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "1.5px",
                                  },
                                  "& .MuiSelect-icon": {
                                    right: "0rem",
                                  },
                                  width: "162px",
                                }}
                                value={user?.name || ""}
                                handleChange={(event) => {
                                  const updatedShareData = values.shareData.map(
                                    (item, i) =>
                                      i === index
                                        ? {
                                            ...item,
                                            name: event.target.value.name,
                                            type: event.target.value.value,
                                          }
                                        : item
                                  );
                                  setFieldValue("shareData", updatedShareData);
                                }}
                              />
                            </Fragment>
                          )}
                          <CustomTooltip
                            title="Delete"
                            arrow
                            placement="top"
                            fontWeight={600}
                            padding="5px 15px"
                          >
                            <IconButton
                              onClick={() =>
                                handleShareDelete(values, setFieldValue, user)
                              }
                            >
                              <DeleteIco stroke="#B42318" />
                            </IconButton>
                          </CustomTooltip>
                        </CommonGrid2>
                      </CommonGrid2>

                      {condition === true && (
                        <CommonGrid2
                          display={"flex"}
                          rowGap={"1rem"}
                          columnGap={"1.5rem"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                        >
                          <CommonGrid2
                            display={"flex"}
                            gap={"5px"}
                            alignItems={"center"}
                          >
                            <Typography variant="subtitle3">
                              Include Resume Upload Portal
                            </Typography>
                            <Switch
                              checked={user.send_resume_portal}
                              onChange={(event) => {
                                const updatedShareData = values.shareData.map(
                                  (item, i) =>
                                    i === index
                                      ? {
                                          ...item,
                                          send_resume_portal:
                                            event.target.checked,
                                          max_resumes: event.target.checked
                                            ? item?.max_resumes || 0
                                            : 0,
                                        }
                                      : item
                                );
                                setFieldValue("shareData", updatedShareData);
                              }}
                            />
                          </CommonGrid2>
                          {user.send_resume_portal && (
                            <Fragment>
                              <CommonGrid2
                                display={"flex"}
                                gap={"5px"}
                                alignItems={"center"}
                              >
                                <Typography variant="subtitle3">
                                  Resume Upload Limit
                                </Typography>
                                <CommonTextField
                                  type="number"
                                  padding="5px 10px"
                                  placeholder={"Enter Number"}
                                  placeholderFontSize={"14px"}
                                  customStyle={{
                                    width: "70px",
                                    "& .MuiInputBase-root": {
                                      padding: "0px",
                                    },
                                  }}
                                  value={user?.max_resumes || 0}
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    value = value.replace(/[^0-9]/g, "");
                                    const updatedShareData =
                                      values.shareData.map((item, i) =>
                                        i === index
                                          ? {
                                              ...item,
                                              max_resumes: parseInt(value),
                                            }
                                          : item
                                      );
                                    setFieldValue(
                                      "shareData",
                                      updatedShareData
                                    );
                                  }}
                                />
                              </CommonGrid2>

                              <CustomTooltip
                                arrow
                                placement="top"
                                title={
                                  generate.copied
                                    ? "Copied!"
                                    : "Copy to Clipboard"
                                }
                                fontSize="12px"
                                padding="5px 10px"
                              >
                                <CustomDiv>
                                  <CommonButton
                                    value={"Copy link"}
                                    startIcon={<CopyLinkIco size={22} />}
                                    gap={"0px"}
                                    color={"#101828"}
                                    onClick={() =>
                                      handleCopyClick(
                                        jobData?.resume_upload_portal_link
                                      )
                                    }
                                    onMouseLeave={handleCopyMouseLeave}
                                    // fontWeight={600}
                                    fontSize={"13px"}
                                    padding={"0px"}
                                    backgroundColor="transparent"
                                    boxShadow={"none"}
                                    customStyle={{
                                      justifyContent: "start",

                                      "&:hover": {
                                        boxShadow: "none",
                                      },
                                    }}
                                  />
                                </CustomDiv>
                              </CustomTooltip>
                            </Fragment>
                          )}
                        </CommonGrid2>
                      )}
                    </CommonGrid2>
                  ))}
                </Grid2>
                <CommonGrid2
                  display={"flex"}
                  justifyContent={"end"}
                  marginTop={values.shareData?.length === 0 ? "10px" : "1.5rem"}
                >
                  <CommonButton
                    fontWeight="600"
                    value="Share"
                    padding={"10px 3rem"}
                    type="submit"
                    disabled={isLoading}
                    loading={isLoading}
                  />
                </CommonGrid2>
              </DialogContent>
            </Form>
          );
        }}
      </Formik>
    </CommonDialogStyle>
  );
}

export default ShareQuickMatch;
